/** @format */

import {useCallback} from 'react';
import {useOptionallyControlledState} from '../hooks/use_optionally_controlled_state';

export const Checkbox = ({
    label,
    checked: controlledChecked,
    name,
    bold,
    small,
    large,
    disabled,
    onChange,
    error,
    className,
    children,
    ...props
}) => {
    const hasError = !!error;
    const [checked, setChecked] = useOptionallyControlledState(
        controlledChecked,
        !!controlledChecked,
        onChange
    );

    const handleChecked = useCallback(() => setChecked(!checked), [setChecked, checked]);

    // apply right classes
    const labelBold = bold ? '-bold' : '';
    const labelSize = small ? '-sm' : large ? '-lg' : '-md';
    const checkboxSize = small ? '--small' : large ? '-large' : '';

    return (
        <div className={`field my-2 ${hasError && 'field--error'}`}>
            <label className={`font-body${labelBold}${labelSize}`}>
                <input
                    className={`control control${checkboxSize} ` + className}
                    type="checkbox"
                    placeholder={label}
                    name={name}
                    disabled={disabled}
                    checked={checked}
                    onChange={handleChecked}
                    aria-invalid={hasError}
                    {...props}
                />
                <span>{children || label}</span>
            </label>
            {hasError && <p className="color-alert-negative">{error}</p>}
        </div>
    );
};

Checkbox.defaultProps = {
    label: 'Label Name',
    disabled: false
};
